import axios from "./axios";

export default {
  namespaced: true,

  state: {
    currentProfileSub: localStorage.getItem("current_subscription") || 0,
    accountName: localStorage.getItem("account_name") || null,
    profiles: [],
    currentProfile: localStorage.getItem("current_profile") || null,
    profileName: localStorage.getItem("profile_name") || null,
    years: []
  },
  getters: {
    gProfiles(state) {
      return state.profiles;
    },
    gCurrentProfile(state) {
      return state.currentProfile;
    },
    gProfileSubscription(state) {
      return state.currentProfileSub;
    },
    gAccountName(state) {
      return state.accountName;
    },
    gProfile(state) {
      return state.profileName;
    }
  },
  actions: {
    aRegisterUser(commit, user) {
      return new Promise((resolve, reject) => {
        axios.post('register', JSON.stringify(user))
          .then(response => {
            if (response.data.status) {
              resolve(1);
              commit('mMessage', response.data.message, {root: true});
            } else {
              commit('mMessage', response.data.message, {root: true});
              resolve(0);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    aAccountProfiles({ commit, rootState, dispatch }) {
      return new Promise((resolve, reject) => {
        
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.userauth.token;
        axios.get('account')
          .then(response => {
            if (response.data.status) {
              commit('mAccountProfiles', (response.data.data))
              resolve(1);
            } else if (response.data.message == "Unauthenticated") {
              //kill everything and move to login page
              dispatch("userauth/aAuthenticated", response.data.message, {root: true});
            }
          })
          .catch((error) => {
            //throw new Error('Higher-level error. ' + error.message)
            console.log("the error")
            reject(error);
          })
          .catch((error) => {
            throw new Error('Higher-level error. ' + error.message);
          })
      })
    },
    aSetProfile({ commit, dispatch }, id) {
      //we have to check and set the subscription of the new profile
      return new Promise((resolve) => {
        commit('mSetProfile', id)
        dispatch('aCheckSubscription')
          .then(res => {
            if (res) {
              resolve(1)
            } else {
              resolve(0)
            }
          })
      })
    },
    aAddProfile({ rootGetters, commit, rootState }, profile) {
      if (rootGetters['userauth/gLoggedIn']) {
        return new Promise((resolve, reject) => {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.userauth.token;
          axios.post('account/newprofile', JSON.stringify(profile))
            .then(response => {
              if (response.data.status) {
                resolve(true);
                commit('mAddProfile', (response.data.data));
                commit('mMessage', response.data.message, {root: true});
              } else {
                commit('mMessage', response.data.message, {root: true});
                resolve(0);
              }
            })
            .catch(error => {
              reject(error);
            })
        })
      }
      //commit('setProfile', profile)
    },
    aDeleteProfile({ rootGetters, commit, rootState }, id) {
      if (rootGetters['userauth/gLoggedIn']) {
        return new Promise((resolve, reject) => {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.userauth.token;
          axios.delete('account/deleteprofile/' + id)
            .then(response => {
              if (response.data.status) {
                resolve(true);
                commit("mMessage", response.data.message, {root: true});
                commit('mDeleteProfile', response.data.data);
              } else {
                commit('mMessage', response.data.data, {root:true});
                resolve(0);
              }
            })
            .catch(error => {
              reject(error);
            })
        })
      }
      //commit('setProfile', profile)
    },
    aCancelProfile({ rootGetters, commit, rootState }, id) {
      if (rootGetters['userauth/gLoggedIn']) {
        return new Promise((resolve, reject) => {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.userauth.token;
          axios.put('account/cancelsus/' + id)
            .then(response => {
              if (response.data.status) {
                resolve(true);
                commit("mMessage", response.data.message, {root: true});
                commit('mCancelProfile', response.data.data);
              } else {
                commit('mMessage', response.data.data, {root:true});
                resolve(0);
              }
            })
            .catch(error => {
              reject(error);
            })
        })
      }
      //commit('setProfile', profile)
    },
    aCheckSubscription({ rootGetters, getters, dispatch, commit, rootState }) {
      
      if (rootGetters['userauth/gLoggedIn']) {
        return new Promise((resolve, reject) => {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.userauth.token
          axios.post('check_subscription/' + getters.gCurrentProfile)
            .then(response => {
              if (response.data.message === "Unauthenticated") {
                dispatch("userauth/aAuthenticated", response.data.message, {root: true});
              } else  {
              if (response.data.status) {
                commit('mProfileName', response.data.data);
                commit('mCheckSubscription', 1);
                resolve(1);
              } else {
                commit('mCheckSubscription', 0);
                resolve(0);
              }
              }

            })
            .catch(error => {
              reject(error)
            })
        })
      }
    },
    aSubscribe({ getters, rootGetters, commit, rootState }, data) {
      if (rootGetters['userauth/gLoggedIn']) {
          return new Promise((resolve, reject) => {
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.userauth.token;
              const parcel = JSON.stringify({ orderId: data.orderID, payerId: data.payerID })
              console.log(parcel)
              axios.post('subscribe/order/' + getters.gCurrentProfile, parcel)
                  .then(response => {
                      if (response.data.status) {
                          commit('mSubscriptionUpdate', 1)
                          resolve(true)
                      }
                  })
                  .catch(error => {
                      reject(error)
                  })
          })
      }
  }
  },
  mutations: {
    mSetAccountName(state, name) {
      localStorage.setItem('account_name', name);
      state.accountName = name
    },
    mProfileName(state, data) {
      var name = data.firstname + " " + data.surname;
      localStorage.setItem('profile_name', name);
      state.profileName = name;
    },
    mAccountProfiles(state, profiles) {
      state.profiles = profiles
    },
    mCheckSubscription(state, status) {
      localStorage.setItem("current_subscription", status)
      state.currentProfileSub = status
    },
    mSubscriptionUpdate(state, subs) {
      localStorage.setItem('current_subscription', subs)
      state.currentProfileSub = subs
    },
    mAddProfile(state, data) {
      state.profiles.unshift(data)
    },
    mSetProfile(state, id) {
      localStorage.setItem('current_profile', id)
      state.currentProfile = id
    },
    mDeleteProfile(state, id) {
      state.profiles = state.profiles.filter(pros => pros.id != id)
    },
    mCancelProfile() {

    }
  }
}